<div id="content" class="main-content">
    <div class="container">
      <div class="page-header">
        <div class="page-title col-lg-12 col-md-12 col-sm-12 col-xs-12 justify-content-between">
          <h2 class="col-sm-12 col-xs-12">
            <b>Enquêtes</b>
          </h2>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col col-lg-12">
            <div class="row" id="cancel-row">
              <div class="col-xl-12 col-lg-12 pr-0 pl-0 layout-spacing">
                <div class="statbox widget box box-shadow">
                  <div class="widget-header">
                    <div class="row">
                    </div>
                  </div>
                  <div class="widget-content widget-content-area pl-0 pr-1">
                    <div *ngIf="ticketsLoading" class="cp-spinner cp-bubble" style="margin: auto; display: block; margin-top: 15%; margin-bottom: 15%;"></div>
                    <div class="table-responsive mb-4" *ngIf="!ticketsLoading">
                      <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                        <thead>
                          <tr>
                            <th>Référence</th>
                            <th>Organisation</th>
                            <th>Nom/Prénom</th>
                            <th>Statut</th>
                            <th>Date de ticket</th>
                            <th>Date d'envoi</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let ticket of alltickets">
                            <td>
                              <a [attr.href]="'ticket/detail/' + ticket.ticket_uuid">
                                <b>{{ ticket.ticketNumber }}</b>
                              </a>
                            </td>
                            <td><b>{{ ticket.organisation }}</b></td>
                            <td>{{ ticket.creator }}</td>
                            <td class="d-flex justify-content-center">
                              <span class="mb-2 ml-2 badge badge-pills" style="font-size: xx-small;" [ngClass]="{
                                'badge-open': ticket.status ==='Ouvert',
                                'badge-resolved': ticket.status ==='Résolu',
                                'badge-reprised': ticket.status ==='Repris',
                                'badge-inProgress': ticket.status ==='En cours',
                                'badge-waiting': ticket.status ==='En attente',
                                'badge-clos': ticket.status ==='Clos'
                              }">{{ ticket.status || '- - -' }}</span>
                            </td>
                            <td>{{ ticket.createdAt }}</td>
                            <td>{{ ticket.sentAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                            <td style="display: flex; justify-content: center; align-items: center;">
                              <i class="flaticon-left-menu icon-large-bold" style="cursor: pointer;" (click)="selectedTicket(ticket)" ></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>    
              </div>
            </div>
          </div>
        </div>        
      </div>
    </div>
  </div>  

  <div class="modal fade" id="surveyResult" tabindex="-1" role="dialog" aria-labelledby="fileModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><b>La reponse d'enquête</b></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <!-- <div *ngIf="surveyResultLoading" class="cp-spinner cp-bubble" style="position: absolute;z-index: 9;margin: auto;display: block;margin-left: 42%;margin-top: 3%;"></div> -->
            <div>
                <div class="d-xl-flex d-lg-flex">
                    <h4 class="mr-auto p-2"><span style="color: #027476;">La réponse de votre client <b>{{ticket?.creator}}</b> à l'enquête de satisfaction</span></h4>
                </div>
                <div class=" col-xl-12 col-lg-12 col-sm-12 p-3 border-white rounded">
                    <div *ngIf="surveyResultLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;margin-bottom: 15%;"></div>
                    <div id="surveyQuestions"></div>
                </div>
            </div>
            </div>
            <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Retour</button>
            </div>
        </div>
    </div>
  </div>